import type { ReactNode } from 'react';
import { cn } from './cn.js';

export interface NavItem {
  key: string;
  label: string;
  href: string;
  active: boolean;
}

/** En-tête sticky : fond opaque, filet 1 px, logo horizontal, navigation principale. */
export function AppHeader({
  logo,
  nav,
  right,
  renderLink,
}: {
  logo: ReactNode;
  nav: NavItem[];
  right?: ReactNode;
  renderLink: (item: NavItem, className: string) => ReactNode;
}) {
  return (
    <header className="sticky top-0 z-30 border-b border-line-soft bg-surface">
      <div className="mx-auto flex max-w-page flex-wrap items-center gap-x-3 px-4 sm:h-16 sm:flex-nowrap sm:gap-x-6 sm:px-8">
        <div className="order-1 flex h-14 shrink-0 items-center sm:h-auto">{logo}</div>
        <nav
          aria-label="Navigation principale"
          className="order-3 flex h-11 basis-full items-stretch gap-1 sm:order-2 sm:h-full sm:min-w-0 sm:flex-1 sm:basis-auto"
        >
          {nav.map((n) =>
            renderLink(
              n,
              cn(
                'relative flex shrink-0 items-center px-3 font-display no-underline text-[15px] font-semibold transition-colors duration-base ease-od',
                'after:absolute after:inset-x-3 after:bottom-0 after:h-0.5 after:rounded-pill after:transition-colors',
                n.active ? 'text-ink after:bg-navy-600' : 'text-ink-3 after:bg-transparent hover:text-ink',
              ),
            ),
          )}
        </nav>
        {right && (
          <div className="order-2 ml-auto flex shrink-0 items-center gap-1 sm:order-3 sm:ml-0">{right}</div>
        )}
      </div>
    </header>
  );
}
